export default {
  ncm: 'NCM',
  'ncm.domain.code': 'Código',
  'ncm.domain.description': 'Descrição',
  'ncm.domain.cest': 'CEST',
  'ncm.domain.taxesPercentage':
    '% aproximada de tributos municipais, estaduais e federais (%)',
  'ncm.domain.modalityDeterminationBcIcms':
    'Modalidade de determinação da BC ICMS',
  'ncm.domain.modalityDeterminationBcIcms.0': '0 - Margem Valor Agregado (%)',
  'ncm.domain.modalityDeterminationBcIcms.1': '1 - Pauta (Valor)',
  'ncm.domain.modalityDeterminationBcIcms.2': '2 - Preço Tabelado Máx. (valor)',
  'ncm.domain.modalityDeterminationBcIcms.3': '3 - Valor da operação',
  'ncm.domain.cstIcms': 'CST ICMS',
  'ncm.domain.csosnIcms': 'CSOSN ICMS',
  'ncm.domain.aliquotIcms': '(%) Aliq. ICMS',
  'ncm.domain.mva': '(%) MVA',
  'ncm.domain.reductionIcms': '(%) Redução de ICMS',
  'ncm.domain.cstPis': 'CST PIS',
  'ncm.domain.aliquotPis': '(%) Aliq. PIS',
  'ncm.domain.cstCofins': 'CST COFINS',
  'ncm.domain.aliquotCofins': '(%) Aliq. COFINS',
  'ncm.domain.aliquotIpi': '(%) Aliq. IPI',
  'ncm.domain.cstIpi': 'CST IPI',
  'ncm.domain.cstIcmsEntry': 'CST ICMS',
  'ncm.domain.cstIpiEntry': 'CST IPI',
  'ncm.domain.cstPisEntry': 'CST PIS',
  'ncm.domain.cstCofinsEntry': 'CST COFINS',

  'ncm.outgoing': 'Saída',
  'ncm.incoming': 'Entrada',
  'ncm.icms/csosn': 'ICMS/CSOSN',
  'ncm.pis/cofins': 'PIS/COFINS',
  'ncm.ipi': 'IPI',
  'ncm.is': 'IS',
  'ncm.ibsCbs': 'IBS/CBS',

  'ncm.create': 'Criar NCM',
  'ncm.create.new': 'Novo NCM',
  'ncm.create.notification.success': 'Sucesso',
  'ncm.create.notification.successDescription': 'NCM criado.',

  'ncm.update': 'Editar NCM',
  'ncm.update.notification.success': 'Sucesso',
  'ncm.update.notification.successDescription': 'NCM editado.',

  'ncm.remove': 'Remover NCM',
  'ncm.remove.alert': 'Você realmente deseja remover o ncm:',
  'ncm.remove.notification.success': 'Sucesso',
  'ncm.remove.notification.successDescription': 'NCM removido.',

  'ncm.generateReport': 'Gerar Relatório',

  'ncm.modal.report.title': 'Gerar Relatório',
  'ncm.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'ncm.modal.report.buttons.pdf': 'Gerar PDF',
  'ncm.modal.report.buttons.rtf': 'Gerar RTF',
  'ncm.modal.report.buttons.csv': 'Gerar CSV',
  'ncm.modal.report.form.description': 'Descrição',
  'ncm.modal.report.form.codeNcm': 'Código NCM',

  'ncm.error.alreadyExists': 'NCM já existe!',

  'ncm.status.message.success': 'Status do NCM alterado com sucesso!',
};
